import ProgressTrackerStyled from './ProgressTracker.styled'

const ProgressTracker = (props) => {
  return <ProgressTrackerStyled {...props} full />
}

export default ProgressTracker
